import {
  getBadgeClassesByIssuerUrl,
  getBadgeMappingsByIdUrl,
  getBadgeMappingsUrl,
  getIssuersUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class AttainmentRuleService {
  static getIssuers = () => {
    return getRequest(getIssuersUrl());
  };

  static getBadgeClassesByIssuer = (entityId) => {
    return getRequest(getBadgeClassesByIssuerUrl(entityId));
  };

  static createBadgeClassByIssuer = (entityId, params) => {
    return postRequest(getBadgeClassesByIssuerUrl(entityId), params);
  };

  static getBadgeMappings = () => {
    return getRequest(getBadgeMappingsUrl());
  };

  static createBadgeMapping = (badgeMapping) => {
    return postRequest(getBadgeMappingsUrl(), badgeMapping);
  };

  static updateBadgeMapping = (badgeMapping) => {
    return putRequest(getBadgeMappingsUrl(), badgeMapping);
  };

  static deleteBadgeMapping = (mappingId) => {
    return deleteRequest(getBadgeMappingsByIdUrl(mappingId));
  };
}
